import Home from "@/components/Home";
import {createWebHistory, createRouter} from "vue-router";
import InsuredEventClaim from "@/components/insurances/InsuredEventClaim";
import PersonalDataForm from "@/components/PersonalDataForm";
import RequestSent from "@/components/RequestSent";
import config from '@/config';

const history = createWebHistory();

const routes = [
    {path: config.folder + '/', name: 'home', component: Home},
    {path: config.folder + '/insuredEventClaim', name: 'insuredEventClaim',  component: InsuredEventClaim},
    {path: config.folder + '/personalDataForm', name: 'PersonalDataForm',  component: PersonalDataForm},
    {path: config.folder + '/requestSent', name: 'RequestSent',  component: RequestSent},
]; // router.

export default createRouter({
    history,
    routes
});